import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="flex flex-wrap items-center gap-2 md:gap-3">
      {categories?.map((category) => {
        const isActive = activeCategory === category?.id;
        
        return (
          <button
            key={category?.id}
            onClick={() => onCategoryChange(category?.id)}
            className={`
              flex items-center gap-2 px-3 md:px-4 py-2 rounded-md text-sm font-medium
              transition-smooth
              ${isActive
                ? 'bg-primary text-primary-foreground shadow-elevation-sm'
                : 'bg-card text-muted-foreground hover:bg-muted hover:text-foreground border border-border'
              }
            `}
          >
            <Icon name={category?.icon} size={16} />
            <span className="whitespace-nowrap">{category?.label}</span>
            <span className={`
              text-xs px-1.5 py-0.5 rounded
              ${isActive ? 'bg-primary-foreground/20' : 'bg-muted'}
            `}>
              {category?.count}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default CategoryFilter;